'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var style = {
  display: 'block',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  borderColor: '#cccccc'
};

exports['default'] = _react2['default'].createClass({

  displayName: 'Demo.Controls.InputMultilineText',

  propTypes: {
    value: _react.PropTypes.string.isRequired,
    onChange: _react.PropTypes.func.isRequired
  },

  handleChange: function handleChange(e) {
    this.props.onChange(e.target.value);
  },

  render: function render() {
    return _react2['default'].createElement('textarea', {
      rows: 4,
      style: style,
      value: this.props.value,
      onChange: this.handleChange
    });
  }

});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-demo/dist/Controls/InputMultilineText.js
// module id = 964
// module chunks = 0